import { Loader2 } from "lucide-react";

/**
 * Shown while a lazily loaded page downloads. Deliberately bare — no site
 * header or layout — because anything this renders ships in the initial
 * bundle for every visitor, including people opening a match link on 3G.
 * (PageLoading renders the full Layout, which pulls in the header, location
 * search and MUI.)
 */
const RouteFallback = () => (
  <div className="flex min-h-[60vh] items-center justify-center" role="status" aria-label="Loading">
    <Loader2 className="h-10 w-10 animate-spin text-black/60 dark:text-white/60" />
  </div>
);

export default RouteFallback;
